import { CompanyDetails } from "../types/CompanyDetails";

// Import image assets so Vite/TS can resolve and bundle them correctly
import retailHero from "../assets/retail-hero.png";
import homeGridImg1 from "../assets/home-grid-img-1.png";
import homeGridImg2 from "../assets/home-grid-img-2.png";
import homeGridImg3 from "../assets/home-grid-img-3.png";

export const companyName = 'SSA Retail Group Limited';
export const companyMotto = 'Explore our strategic, mission-aligned food & grocery retail solutions.';
export const heroImageUrl = retailHero;
export const companyImages = [
    { src: homeGridImg1, alt: "Responsibly sourced product display", className: "col-span-1 row-span-2" },
    { src: homeGridImg2, alt: "Local artisan goods on display", className: "col-span-1 row-span-1" },
    { src: homeGridImg3, alt: "Alternative product packaging", className: "col-span-1 row-span-1" },
];

export const companyTextData: CompanyDetails = {
        title: 'Your Local Shop. For the Community. Simply Convenient.',
        description: 'As SSA Retail Group Limited, we believe the best retail experience is rooted in the neighborhood. We are committed to being Your Local Shop, serving the community with unparalleled convenience. This means ensuring our shelves are stocked not just quickly, but thoughtfully, curating a selection of essential and responsibly sourced goods. Our mission is to make quality, conscious shopping Simply Convenient for every neighbor.',
        points: [
            'Ethically Sourced Goods: Prioritizing products acquired through responsible and transparent supply chains.',
            'Curated Local & Global Selection: Featuring the best in local artisan goods alongside carefully chosen global brands.',
            'Sustainable Packaging Alternatives: Actively seeking and implementing alternative product materials and packaging to reduce environmental impact.',
            'Mission-Driven Merchandise: Stocking mission-connected goods whose purchase supports social or environmental causes.',
            'Resilient Supply Chain Management: Employing proactive strategies to mitigate supply chain disruption, ensuring our stores are consistently stocked.'
        ]
    };

